<template>
  <div class="center-bottom">
    <div class="mhead">
      <div class="item active" v-for="(item, i) in types" :key="i">
        <div class="label" :class="item.name"></div>
        {{ item.name }}:{{ item.num }}
      </div>
    </div>
    <div class="table">
      <div class="thead">
        <div class="i-item rank">序号</div>
        <div class="i-item name">驿站名称</div>
        <div class="i-item type">驿站类型</div>
        <div class="i-item percent">累计人数</div>
        <div class="i-item kcal">今日人数</div>
      </div>
      <div class="tbody high">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in p_list" :key="item.name">
            <div class="i-item rank">{{ i + 1 + p_step * page_size }}</div>
            <div class="i-item name">{{ item.name }}</div>
            <div class="i-item type">
              <div class="label" :class="item.type"></div>
              {{ item.type }}
            </div>
            <div class="i-item percent">{{ item.num }}</div>
            <div class="i-item kcal">{{ item.today_num }}</div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

let ltimer = null

export default {
  data() {
    return {
      page_size: 5,
      p_step: 0,
      pList: [],
      p_list: [],

      types: [],
    }
  },
  mounted() {
    this.get_data()
  },
  methods: {
    get_data() {
      api.common.stadiumList({ gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
        this.init(r.data.stadium_list)

        const types = []

        Object.keys(r.data.stadium_num).forEach((key) => {
          if (key == '全部') {
            types.unshift({
              name: key,
              num: r.data.stadium_num[key],
            })
          } else {
            types.push({
              name: key,
              num: r.data.stadium_num[key],
            })
          }
        })

        this.types = types
      })
    },
    init(list) {
      this.page_size = 8

      this.p_step = 0
      this.pList = list

      this.$set(this, 'p_list', list.slice(0, this.page_size))
      ltimer = setInterval(() => {
        this.p_list = []

        setTimeout(() => {
          let p_step = this.p_step + 1

          // console.log(p_step, Math.floor(this.pList.length / this.page_size))

          if (p_step > Math.ceil(this.pList.length / this.page_size) - 1) {
            p_step = 0
          }

          this.p_list = this.pList.slice(this.page_size * p_step, this.page_size * p_step + this.page_size)

          this.p_step = p_step
        }, 600)
      }, this.page_size * 2000)
    },
  },
}
</script>

<style scoped>
.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>

<style lang="less" scoped>
.center-bottom {
  padding: 0 20px;
  .mhead {
    margin-top: -52px;
    padding: 13px 24px 12px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #fff;
      opacity: 0.33;
      .label {
        width: 18px;
        height: 18px;
        margin-right: 8px;
        border-radius: 2px;
        &.综合型 {
          background: #ff6c40;
        }
        &.一般型 {
          background: #03bce2;
        }
        &.简易型 {
          background: #f7b500;
        }
      }
      &.active {
        opacity: 1;
      }
      & + .item {
        margin-left: 20px;
      }
    }
  }
  .table {
    margin: 20px 0px 0;
    .thead {
      display: flex;
      align-items: center;
      background: rgba(68, 96, 218, 0.2);
    }
    .tbody {
      height: 200px;
      overflow: auto;
      &.high {
        height: 452px;
      }
      .item {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 2px 0;
        border-bottom: 1px solid rgba(68, 96, 218, 0.2);
        .i-item {
          font-size: 16px;
          font-weight: normal;
          padding: 6px 0;
          color: #82a9ef;
          &.name {
            box-sizing: border-box;
            width: 30%;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 文本不换行 */
            text-overflow: ellipsis; /* 省略的文本用省略号表示 */
          }
        }
      }
    }
    .i-item {
      font-size: 16px;
      font-weight: 500;
      color: #00fbff;
      padding: 6px 0;
      &.rank {
        text-align: center;
        width: 20%;
      }
      &.name {
        width: 30%;
        padding-right: 12px;
        box-sizing: border-box;
        overflow: hidden; /* 超出部分隐藏 */
        white-space: nowrap; /* 文本不换行 */
        text-overflow: ellipsis; /* 省略的文本用省略号表示 */
      }
      &.type {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        .label {
          width: 18px;
          height: 18px;
          margin-right: 8px;
          border-radius: 2px;
          &.综合型 {
            background: #ff6c40;
          }
          &.一般型 {
            background: #03bce2;
          }
          &.简易型 {
            background: #f7b500;
          }
        }
      }
      &.percent {
        text-align: center;
        width: 15%;
      }
      &.kcal {
        text-align: center;
        width: 15%;
      }
    }
  }
}
</style>
